export default "__VITE_ASSET__c8899b55__"